import { WebAudioSuper } from "./webaudio_super.js";

class WebAudioNode extends WebAudioSuper {
  namespace = "webaudio:node";
}

const webAudioNode = new WebAudioNode();
export { webAudioNode, WebAudioNode };
